import { render, staticRenderFns } from "./knowledge-single.vue?vue&type=template&id=505b4b43"
import script from "./knowledge-single.vue?vue&type=script&lang=js"
export * from "./knowledge-single.vue?vue&type=script&lang=js"
import style0 from "./knowledge-single.vue?vue&type=style&index=0&id=505b4b43&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports